/** @jsxImportSource @emotion/react */
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { Divider } from "../../components/Divider";
import { css } from "@emotion/react";
import { SalesChannelItem } from "./SalesChannelItem";
import { CardBody } from "../../components/page-skeleton/CardBody";
import { Shop } from "./model/ShopSuccessResponse";
import { SalesChannelListItem } from "./models/sales-channel";
import { MutateSalesChannelSelector } from "./MutateSalesChannelSelector";

// Hacking width until all cards on page are updated
export const cardAdditionalStyling = css`
  max-width: 1174px !important;
`;

export const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

// Normally we would use PageWrapper component, but other components on the page are not updated yet
export const cardWrapperStyle = css`
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

type Props = {
  shop: Shop;
  salesChannels: SalesChannelListItem[];
};

export const SalesChannelsList = ({ shop, salesChannels }: Props) => {
  const hasSalesChannels = salesChannels && salesChannels.length > 0;

  return (
    <div css={cardWrapperStyle}>
      <CardContainer css={cardAdditionalStyling}>
        <PageHeader title="Sales channels">
          {hasSalesChannels && (
            <MutateSalesChannelSelector shop={shop} type="create" />
          )}
        </PageHeader>
        {hasSalesChannels ? (
          <div css={wrapperStyle}>
            <Divider />
            {salesChannels.map((salesChannel, i) => (
              <SalesChannelItem
                key={i}
                showDivider={i + 1 !== salesChannels.length}
                salesChannel={salesChannel}
                shop={shop}
              />
            ))}
          </div>
        ) : (
          <CardBody css={cardBodyAdditionalStyling}>
            <MutateSalesChannelSelector shop={shop} type="placeholder" />
          </CardBody>
        )}
      </CardContainer>
    </div>
  );
};
